import {
  SET_DIALOG_RECONNECTING_INFORMATION,
  SET_DIALOG_TRANSFER_CALL_RECEIVED,
  SET_DIALOG_PAUSE_ALERT,
  SET_DIALOG_AGENT_ABSENT,
} from '@/store/mutation-types';

const actions = {
  openDialogReconnectingInformation({ commit }) {
    commit(SET_DIALOG_RECONNECTING_INFORMATION, true);
  },
  closeDialogReconnectingInformation({ commit }) {
    commit(SET_DIALOG_RECONNECTING_INFORMATION, false);
  },
  openDialogTransferCallReceived({ commit }) {
    commit(SET_DIALOG_TRANSFER_CALL_RECEIVED, true);
  },
  closeDialogTransferCallReceived({ commit }) {
    commit(SET_DIALOG_TRANSFER_CALL_RECEIVED, false);
  },
  openDialogPauseAlert({ commit }) {
    commit(SET_DIALOG_PAUSE_ALERT, true);
  },
  closeDialogPauseAlert({ commit }) {
    commit(SET_DIALOG_PAUSE_ALERT, false);
  },
  openAgentAbsentDialog({ commit }) {
    commit(SET_DIALOG_AGENT_ABSENT, true);
  },
  closeAgentAbsentDialog({ commit }) {
    commit(SET_DIALOG_AGENT_ABSENT, false);
  },
};

export default actions;
